import { Link } from "@tanstack/react-router";

/**
 * Footer i tre spalter (v2): definition · Gennem tiden · Vores løfte.
 * Diskret "Støt Flâneriet"-link i sepia. Ingen tunge grafiske elementer.
 */
export function SiteFooter() {
  return (
    <footer className="content-canvas rule-double mt-16 pt-10 pb-8">
      <div className="grid gap-10 md:grid-cols-[1.3fr_1fr_1fr] md:gap-12">
        <div>
          <p className="font-serif text-[22px] md:text-[26px] mb-3">Flâneriet</p>
          <p className="font-serif italic font-light text-[15px] leading-[1.6] text-ink-soft m-0">
            Flâneur <span className="not-italic text-muted">(fr.)</span> – en,
            der spadserer uden mål; iagttageren, der lader sig drive af
            nysgerrighed frem for hastværk.
          </p>
        </div>

        <div>
          <p className="eyebrow mb-3.5">Gennem tiden</p>
          <ul className="flex flex-col gap-2.5 font-serif text-[15px] md:text-[16px] text-ink m-0 p-0 list-none">
            <li>
              <Link to="/artikler" className="hover:text-accent transition-colors">
                Arkiv – alle fund
              </Link>
            </li>
            <li>
              <Link to="/bogmaerker" className="hover:text-accent transition-colors">
                Min samling
              </Link>
            </li>
            <li>
              <Link to="/om-kuratoren" className="hover:text-accent transition-colors">
                Om kuratoren
              </Link>
            </li>
            <li>
              <Link to="/stoet" className="text-accent hover:text-accent-dark transition-colors">
                Støt Flâneriet
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="eyebrow mb-3.5">Vores løfte</p>
          <p className="font-serif font-light text-[14.5px] leading-[1.7] text-ink-soft m-0">
            Ingen sporing. Alle henvisninger fører til den oprindelige kilde.
            Læses langsomt – én tekst, ét glas, én tanke ad gangen.
          </p>
        </div>
      </div>

      <div className="mt-8 pt-5 border-t border-rule">
        <p className="font-serif font-light text-[13px] leading-[1.7] text-muted-faint m-0">
          Flâneriet er et personligt, kurateret samlingspunkt for langsomt liv
          og sanselig fordybelse: naturvin og vinkultur, jazz og klassisk musik,
          samtidskunst, poesi og litteratur, god mad, cykling samt stoicisme og
          levekunst.
        </p>
      </div>

      <div className="mt-5 pt-4 border-t border-rule flex flex-wrap justify-between gap-2 font-serif text-[11px] tracking-[0.12em] uppercase text-muted">
        <span>© MMXXVI Flâneriet</span>
        <span>Langsomt liv · dagligt kurateret</span>
      </div>
    </footer>
  );
}
